// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { useMemo } from "@mairistem/tools";

import { NotificationService } from "../services";

import { DataProvider } from "../../libs/components/DataProvider";

export const NotificationDataProvider = (props) => {
	const { children, user } = props;

	const [notifications, loading, fetching] =
		NotificationService.queryNotifications(user);

	return useMemo(
		() => (
			<DataProvider data={notifications} loading={loading} fetching={fetching}>
				{children}
			</DataProvider>
		),
		[children, loading, fetching, notifications],
	);
};
